export const formatMonsterTraitText = (text: string) => {
	const patterns = [
		'Бросок\\sатаки,\\sв\\sближнем\\sбою\\sили\\sдистанционной:',
		'Бросок\\sатаки\\sв\\sближнем\\sбою:',
		'Бросок\\sдистанционной\\sатаки:',
		'Провал\\sили\\sуспех:',
		'Попадание\\sили\\sпромах:',
		'(Попадание|Ответ|Промах|Провал|Успех|Условие|Эффект):',
		'Испытание (Силы|Ловкости|Выносливости|Интеллекта|Мудрости|Харизмы):',
		'(Первый|Второй) провал:',
		'Последующие\\sпровалы:',
		'Ответ\\s—',
		'Провал\\sна\\s\\d+\\sили\\sболее:',
		'Критический удар:',
	];

	patterns.forEach((pattern) => {
		const regex = new RegExp(pattern, 'g');
		text = text.replace(regex, (match) => `_${match}_`);
	});

	return text;
};
